import React from "react";
import { Card, Flex, Text, toast } from "@jsq/ds/core";
import { Form } from "@jsq/ds/forms";
import { Column, ColumnContainer } from "@jsq/ds/layouts";
import { DocumentTracker } from "../../../components/DocumentTracker";
import { FormStepFooter } from "../../../components/FormStepFooter";
import { PayeePaymentPrefDisplayCard } from "../../../components/PayeePaymentPrefDisplayCard";
import { PaymentDetailField } from "../../../components/PaymentDetailField";
import { PayeeStepActionTypes, PayeeWorkflowModes } from "../../../Context/constants";
import {
  useBasePayeeReducerContext,
  usePayeeWorkflowDispatchContext,
  usePayeeWorkflowContext,
} from "../../../Context/PayeeContext";
import { SubmitForReviewText } from "../../../PayeeVendorWorkflow/constants";
import {
  payeeDetailsColumnStyles,
  stepColumnContainerStyles,
  stepContainerStyles,
} from "../../../styles_vanilla.css";
import { useSaveInvestmentPayeeHandler } from "./hooks/useSaveInvestmentPayeeHandler";
import { payeeDetailHeadingStyles } from "./styles_vanilla.css";

type InvestmentReviewStepProps = { onPayeeCreateSuccess?: (createdPayee?: unknown) => void };

export const InvestmentReviewStep: React.FC<InvestmentReviewStepProps> = ({
  onPayeeCreateSuccess,
}: InvestmentReviewStepProps) => {
  const stepDispatch = usePayeeWorkflowDispatchContext();
  const { mode } = usePayeeWorkflowContext();
  const { supportingDocuments, payeeName, arenaId, arenaName, paymentPref } =
    useBasePayeeReducerContext();
  const paymentPrefId = paymentPref?.id;

  const title_card =
    mode === PayeeWorkflowModes.EDIT ? "Review payee changes" : "Review new payee";

  const { savePayee, loading } = useSaveInvestmentPayeeHandler(
    onPayeeCreateSuccess ? { onSuccess: onPayeeCreateSuccess } : undefined,
  );

  if (!payeeName || !arenaId || !supportingDocuments || !paymentPrefId) {
    toast.error("Missing required information");
    return null;
  }

  const handleSubmit = async () => {
    await savePayee();
  };

  return (
    <div className={stepContainerStyles}>
      <Form initialValues={{}} onSubmit={handleSubmit}>
        <ColumnContainer className={stepColumnContainerStyles}>
          <Column size={"fluid"}>
            <DocumentTracker
              documentName={supportingDocuments?.[0]?.name ?? ""}
              documentUrl={supportingDocuments?.[0]?.localUrl ?? ""}
            />
          </Column>
          <Column size={"fluid"} className={payeeDetailsColumnStyles}>
            <Card padding="lg" title={title_card}>
              <Flex flexDirection="column" gap={16}>
                <Text variant="strong-md">Client details</Text>
                <PaymentDetailField label="Client" value={arenaName} />
                <Text variant="strong-md" className={payeeDetailHeadingStyles}>
                  Payee details
                </Text>
                <PaymentDetailField label="Investment" value={payeeName} />
                <Text variant="strong-md" className={payeeDetailHeadingStyles}>
                  Payment instructions
                </Text>
                <PayeePaymentPrefDisplayCard paymentPref={paymentPref} />
              </Flex>
            </Card>
          </Column>
        </ColumnContainer>
        <FormStepFooter
          onBack={() => {
            stepDispatch({ type: PayeeStepActionTypes.DECREMENT_STEP });
          }}
          submitText={SubmitForReviewText}
          submitDisabled={loading}
        />
      </Form>
    </div>
  );
};

export default InvestmentReviewStep;
